import React, {Fragment} from "react";
import moment from "moment";
import {CardBody, CardText, CardTitle} from "reactstrap";
import {FaThumbsDown, FaThumbsUp} from "react-icons/fa";
import {StatusBadge} from "./StatusBadge";

export const InventoryCard = ({data}) => {
  const {serial, mac, is_claimed, claimed_by, date_claimed, status} = data;
  return (
    <CardBody>
      <CardTitle tag="h3">
        <div>Serial: {serial}</div>
        Mac: {mac}
      </CardTitle>
      <CardText>
        <div data-cy="card-status">
          <span style={{marginRight: "10px"}}>Status</span>
          <StatusBadge status={status} />
        </div>
        <div>
          <span style={{marginRight: "10px"}}>Claimed</span>
          {is_claimed ? (
            <FaThumbsUp className="text-green" />
          ) : (
            <FaThumbsDown className="text-red" />
          )}
        </div>
        {is_claimed && (
          <Fragment>
            <div>Claimed By: {claimed_by}</div>
            <div>
              <span>Claimed On: </span>{" "}
              {date_claimed ? moment(date_claimed).format("MMMM Do YYYY") : "-"}
            </div>
          </Fragment>
        )}
      </CardText>
    </CardBody>
  );
};
